<template>
    <div
        class="BullDropdown"
        :class="{
            'BullDropdown--is-open': open,
            'BullDropdown--has-selected-option': selectedOption,
        }"
    >
        <button
            class="BullDropdown__btn"
            @click="toggleOpen"
            @mouseover="cursorStore.setCursorType('link-hover')"
            @mouseleave="cursorStore.setCursorType('default')"
        >
            {{ calcButtonText }}
            <span class="BullDropdown__caret">
                <FontIcon icon="caret" />
            </span>
        </button>
        <ul class="BullDropdown__list">
            <li
                class="BullDropdown__list-item"
                :class="{
                    'BullDropdown__list-item--selected': option.selected,
                }"
                v-for="option in options"
                @click="
                    emits(
                        'update:modelValue',
                        modelValue === option.value ? '' : option.value,
                    )
                "
                @mouseover="cursorStore.setCursorType('link-hover')"
                @mouseleave="cursorStore.setCursorType('default')"
            >
                {{ option.displayValue }}
            </li>
        </ul>
    </div>
</template>

<script setup>
const props = defineProps({
    modelValue: {
        type: String,
        default: '',
    },
    buttonText: {
        type: String,
        required: true,
    },
    options: {
        type: Object,
        required: false,
        default: () => ({}),
    },
    open: {
        type: Boolean,
        default: false,
    },
})

const emits = defineEmits(['update:modelValue', 'opened', 'closed'])

const cursorStore = useCursorStore()

const selectedOption = computed(() => {
    return props.options.find(({ selected }) => selected)
})

const calcButtonText = computed(() => {
    if (selectedOption.value) return selectedOption.value.displayValue

    return props.buttonText
})

function toggleOpen() {
    if (props.open) {
        emits('closed')
    } else {
        emits('opened')
    }
}
</script>

<style lang="scss" scoped>
.BullDropdown {
    position: relative;
    text-transform: uppercase;
}

.BullDropdown--is-open {
    .BullDropdown__list {
        display: block;
    }

    .BullDropdown__caret {
        transform: rotate(180deg);
    }
}

.BullDropdown--has-selected-option {
    .BullDropdown__btn {
        border: 1px solid var(--lime-green);
        background-color: rgba(var(--lime-green-rgb), 0.1);
    }
}

.BullDropdown__btn {
    @include label-lg;

    color: var(--white);
    border: 1px solid var(--white);
    padding: 20px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &:focus {
        outline: none;
        border: 1px solid var(--lime-green);
    }
}

.BullDropdown__caret {
    display: inline-block;
    transition: transform 0.1s ease;
    transform: rotate(0);
    margin-left: 0.5rem;
}

.BullDropdown__list {
    display: none;
    position: absolute;
    top: 100%;
    background-color: var(--black);
    z-index: 2;
    width: 100%;
    margin-top: 0.75rem;
    border: 1px solid var(--white);
    max-height: 250px;
    overflow: auto;
}

.BullDropdown__list-item {
    @include label-lg;

    padding: 1rem;

    &:nth-child(odd) {
        background-color: var(--black-20);
    }

    &:hover {
        background-color: var(--lime-green);
        color: var(--black);
    }
}

.BullDropdown__list-item--selected {
    color: var(--lime-green);
}
</style>
